import { render, staticRenderFns } from "./PersonWebProxy.vue?vue&type=template&id=21759614"
import script from "./PersonWebProxy.vue?vue&type=script&lang=js"
export * from "./PersonWebProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports